import "./style.css";

export default class TagsList {
  static selector = ".tags-list";

  constructor(block) {
    this.block = block;
    this.translateX = 0;
    this.oW = -1;
    this.initTags(block);
    //this.collapseTags(block);
    this.block.addEventListener("click", this.onClick);

    window.addEventListener("load", () => {
      this.collapseTags(block);
    });
    setTimeout(() => {
      this.collapseTags(block);
    }, 200);
  }

  onClick = event => {
    if (this.dragging) {
      event.preventDefault();
    }
  };

  initTags = el => {
    const tags = [...el.querySelectorAll(".tags-list__tag")];
    el.tags = [...tags];
  };

  collapseTags = el => {
    if (
      el.classList.contains("expanded") ||
      (this.oW && this.oW === el.offsetWidth)
    ) {
      return;
    }

    this.oW = el.offsetWidth;

    const list = el.querySelector("ul");
    [...list.childNodes].forEach(el => list.removeChild(el));
    el.tags.forEach(tag => {
      list.insertBefore(tag, null);
    });
    const tags = [...el.tags];
    let remainder = [];
    let ellipsis = document.createElement("li");
    let anchor = document.createElement("span");
    ellipsis.insertBefore(anchor, null);
    ellipsis.classList.add(
      "tags-list__tag",
      "tags-list__tag--red-transparent",
      "ellipsis"
    );
    // ellipsis.addEventListener("click", () => {
    //   this.expandTags(el);
    // });
    let index = 0;

    while (el.scrollWidth > el.offsetWidth) {
      const last = tags.pop();
      remainder.push(last);
      list.removeChild(last);
      index++;
      anchor.innerText = `${index}+`;
      if (ellipsis.parentElement == null) {
        list.insertBefore(ellipsis, null);
      }
    }
  };

  expandTags = el => {
    el.classList.add("expanded");
    const list = el.querySelector("ul");
    [...list.childNodes].forEach(el => list.removeChild(el));
    el.tags.forEach(tag => {
      list.insertBefore(tag, null);
    });

    list.addEventListener("mousedown", this.startDragTags);
    list.addEventListener("touchstart", this.startDragTags, true);
    document.addEventListener("touchmove", this.dragTags, { passive: false });
    this.draggingTag = list;
    const parent = this.draggingTag.parentNode;
    parent.classList.add("begin");
  };

  startDragTags = e => {
    const x = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    const y = (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;
    const target = e.currentTarget;
    document.addEventListener("dragstart", this.cancelEvent);
    document.addEventListener("mousemove", this.dragTags);
    document.addEventListener("mouseup", this.endDragTags);
    document.addEventListener("touchend", this.endDragTags);
    this.dragging = false;
    target.style.cursor = "grabbing";
    this.mouseX = x;
    this.minTranslateTag = -(target.scrollWidth + 1) + this.block.offsetWidth;
    this.canDrag = true;
    if (e.type == "touchstart") {
      this.firstClientX = x;
      this.firstClientY = y;
    }
  };

  cancelEvent = e => e.preventDefault();

  dragTags = e => {
    if (!this.canDrag) {
      return;
    }
    const x = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    const y = (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;

    if (e.type == "touchmove") {
      const minValue = 5; // threshold

      this.clientX = x - this.firstClientX;
      this.clientY = y - this.firstClientY;

      // Vertical scrolling does not work when you start swiping horizontally.
      if (Math.abs(this.clientX) > minValue && e.cancelable) {
        //do not scroll
        e.preventDefault();
      } else {
        //scroll
        return;
      }
    } else {
      //mouse - ignore
      e.preventDefault();
    }

    this.dragging = true;
    this.draggingTag.classList.add("dragging");
    this.translateX += x - this.mouseX;
    this.translateX = Math.max(
      Math.min(this.translateX, 0),
      this.minTranslateTag
    );

    const parent = this.draggingTag.parentNode;
    if (this.translateX == 0) {
      parent.classList.add("begin");
    } else {
      parent.classList.remove("begin");
    }

    if (this.translateX == this.minTranslateTag) {
      parent.classList.add("end");
    } else {
      parent.classList.remove("end");
    }

    this.mouseX = x;

    this.draggingTag.style.transform = `translateX(${this.translateX}px)`;
  };

  endDragTags = e => {
    document.removeEventListener("dragstart", this.cancelEvent);
    document.removeEventListener("mousemove", this.dragTags);
    document.removeEventListener("mouseup", this.endDragTags);
    document.removeEventListener("touchend", this.endDragTags);
    this.draggingTag.style.cursor = "";
    this.draggingTag.classList.remove("dragging");
    this.canDrag = false;
  };

  onResize = () => {
    this.collapseTags(this.block);
  };
}
